import api, { unwrap } from './client';
import { opsViaSop } from './opsRoute';

// Le rôle Opérations passe par `/api/sop/capex` (mêmes fonctions serveur).
const base = () => (opsViaSop() ? '/sop/capex' : '/financials/capex');

/* Plan d'investissement — un bien, une ligne, tous les exercices.
   Le calcul (amortissement, valeur nette) vit au SERVEUR : ici, rien que des
   appels. */
export const listCapexItems = (tenantId) =>
  unwrap(api.get(`${base()}/${tenantId}`));

// Vue pluriannuelle : une colonne par exercice, sur l'horizon du client.
export const getCapexPlan = (tenantId, year) =>
  unwrap(api.get(`${base()}/${tenantId}/plan`, { params: { year } }));

// Amortissement, valeur nette et acquisitions du parc, mois par mois.
export const getCapexSchedule = (tenantId, year) =>
  unwrap(api.get(`${base()}/${tenantId}/schedule`, { params: { year } }));

export const createCapexItem = (tenantId, payload) =>
  unwrap(api.post(`${base()}/${tenantId}`, payload));

export const patchCapexItem = (tenantId, itemId, payload) =>
  unwrap(api.patch(`${base()}/${tenantId}/${itemId}`, payload));

export const deleteCapexItem = (tenantId, itemId) =>
  unwrap(api.delete(`${base()}/${tenantId}/${itemId}`));

/* Actifs existants — les POSTES du bilan, leur taux, leurs mois, leur cession.
   Le patch porte sur un poste ET une année : les mois d'amortissement et la
   cession appartiennent à l'exercice, pas au poste. */
export const getAssetsView = (tenantId, year) =>
  unwrap(api.get(`${base()}/${tenantId}/assets`, { params: { year } }));

export const getAssetsSchedule = (tenantId, year) =>
  unwrap(api.get(`${base()}/${tenantId}/assets/schedule`, { params: { year } }));

export const patchAsset = (tenantId, lineId, year, payload) =>
  unwrap(api.patch(`${base()}/${tenantId}/assets/${lineId}`, payload, { params: { year } }));
